import Vue from 'vue/dist/vue.esm';

import 'vue-hotel-datepicker/dist/vueHotelDatepicker.css'

import HotelDatePicker from 'vue-hotel-datepicker/dist/vueHotelDatepicker.umd.js';
Vue.component('vue-hotel-datepicker', HotelDatePicker);

import qitDatepickerRange from './src/qit-datepicker-range';
Vue.component('qit-datepicker-range', qitDatepickerRange);
import qitDropdownListControl from './src/qit-dropdown-list-control';
Vue.component('qit-dropdown-list-control', qitDropdownListControl);
import qitDropdownSelectWrap from './src/qit-dropdown-select-wrap';
Vue.component('qit-dropdown-select-wrap', qitDropdownSelectWrap);
import qitExtraService from './src/qit-extra-service';
Vue.component('qit-extra-service', qitExtraService);
import qitFacebookSignInBtn from './src/qit-facebook-sign-in-btn';
Vue.component('qit-facebook-sign-in-btn', qitFacebookSignInBtn);
import qitGallerySwiper from './src/qit-gallery-swiper';
Vue.component('qit-gallery-swiper', qitGallerySwiper);
import qitGallerySwiperLightbox from './src/qit-gallery-swiper-lightbox';
Vue.component('qit-gallery-swiper-lightbox', qitGallerySwiperLightbox);
import qitGoogleSignInBtn from './src/qit-google-sign-in-btn';
Vue.component('qit-google-sign-in-btn', qitGoogleSignInBtn);
import qitGuestsIcons from './src/qit-guests-icons';
Vue.component('qit-guests-icons', qitGuestsIcons);
import qitInput from './src/qit-input';
Vue.component('qit-input', qitInput);
import qitModalDialog from './src/qit-modal-dialog';
Vue.component('qit-modal-dialog', qitModalDialog);
import qitRestrictionsReasons from './src/qit-restrictions-reasons';
Vue.component('qit-restrictions-reasons', qitRestrictionsReasons);
import qitRraItemGuests from './src/qit-rra-item-guests';
Vue.component('qit-rra-item-guests', qitRraItemGuests);
import qitRraItem from './src/qit-rra-item';
Vue.component('qit-rra-item', qitRraItem);
import qitSelect from './src/qit-select';
Vue.component('qit-select', qitSelect);
import qitSelectRoomGuests from './src/qit-select-room-guests';
Vue.component('qit-select-room-guests', qitSelectRoomGuests);
import qitSelectRooms from './src/qit-select-rooms';
Vue.component('qit-select-rooms', qitSelectRooms);
import qitSelectRra from './src/qit-select-rra';
Vue.component('qit-select-rra', qitSelectRra);
import qitSimpleTooltip from './src/qit-simple-tooltip';
Vue.component('qit-simple-tooltip', qitSimpleTooltip);
import qitStepsPagination from './src/qit-steps-pagination';
Vue.component('qit-steps-pagination', qitStepsPagination);

import qitChildAge from './src/search-rooms-guests/qit-child-age';
Vue.component('qit-child-age', qitChildAge);

import qitIncDec from './src/search-rooms-guests/qit-inc-dec';
Vue.component('qit-inc-dec', qitIncDec);

import qitSearchRoomsGuests from './src/search-rooms-guests/qit-search-rooms-guests';
Vue.component('qit-search-rooms-guests', qitSearchRoomsGuests);

import qitRoomsRatesFilter from './src/qit-rooms-rates-filter';
Vue.component('qit-rooms-rates-filter', qitRoomsRatesFilter);

//new begin
import qitInputText from './src/qit-input-text';
Vue.component('qit-input-text', qitInputText);

import qitInputSelect from './src/qit-input-select';
Vue.component('qit-input-select', qitInputSelect);

import qitInputPhone from './src/qit-input-phone';
Vue.component('qit-input-phone', qitInputPhone);

import qitInputRadio from './src/qit-input-radio';
Vue.component('qit-input-radio', qitInputRadio);

import qitInputChbox from './src/qit-input-chbox';
Vue.component('qit-input-chbox', qitInputChbox);

import qitInputRadioGroup from './src/qit-input-radiogroup';
Vue.component('qit-input-radiogroup', qitInputRadioGroup);

import qitInputMinMaxRangeSlider from './src/qit-input-minmax-range-slider';
Vue.component('qit-input-minmax-range-slider', qitInputMinMaxRangeSlider);

import qitGetMyBookingForm from './src/clients/qit-get-my-booking-form';
Vue.component('qit-get-my-booking-form', qitGetMyBookingForm);

import qitClientLoginForm from './src/clients/qit-login-form';
Vue.component('qit-login-form', qitClientLoginForm);

import qitClientFpassForm from './src/clients/qit-fpass-form';
Vue.component('qit-fpass-form', qitClientFpassForm);

import qitClientRegForm from './src/clients/qit-registration-form';
Vue.component('qit-registration-form', qitClientRegForm);

import qitClientLoginRegistrationFpassForms from './src/clients/qit-login-registration-fpass-forms';
Vue.component('qit-login-registration-fpass-forms', qitClientLoginRegistrationFpassForms);

import qitPasswordResetForm from './src/clients/qit-password-reset-form';
Vue.component('qit-password-reset-form', qitPasswordResetForm);

import qitChangePasswordForm from './src/clients/qit-change-password-form';
Vue.component('qit-change-password-form', qitChangePasswordForm);

import qitChangeProfileForm from './src/clients/qit-change-profile-form';
Vue.component('qit-change-profile-form', qitChangeProfileForm);


import qitBookingItemFormChangeGuests from './src/booking/qit-booking-item-form-change-guests.js';
Vue.component('qit-booking-item-form-change-guests', qitBookingItemFormChangeGuests);

import qitBookingItemFormCancel from './src/booking/qit-booking-item-form-cancel.js';
Vue.component('qit-booking-item-form-cancel', qitBookingItemFormCancel);

import qitBookingFormCancel from './src/booking/qit-booking-form-cancel.js';
Vue.component('qit-booking-form-cancel', qitBookingFormCancel);

import qitBookingFormChangeClientDetails from './src/booking/qit-booking-form-change-client-details.js';
Vue.component('qit-booking-form-change-client-details', qitBookingFormChangeClientDetails);

import qitSidebarControl from './src/qit-sidebar-control.js';
Vue.component('qit-sidebar-control', qitSidebarControl);

import qitGoogleReCaptchaV3 from './src/qit-google-recaptcha-v3.js';
Vue.component('qit-google-recaptcha-v3', qitGoogleReCaptchaV3);

import qitReorderingContainer from './src/qit-reordering-container.js';
Vue.component('qit-reordering-container', qitReorderingContainer);
//new end

import VueI18n from 'vue-i18n/dist/vue-i18n.esm';

function createVueApp(vueAppElement, vueAppConfig){

  Vue.use(VueI18n);

	return new Vue({
		el: vueAppElement,
		i18n: new VueI18n(vueAppConfig.i18nSettings),
		data(){
			return {
				inData: vueAppConfig.inData,
				currency: vueAppConfig.currency,
				dateFormat: vueAppConfig.dateFormat,
				precision: vueAppConfig.roundPrecision,
				isActiveRoomsGuestsControl: vueAppConfig.isActiveRoomsGuestsControl,
				isActiveSearchByPromoCode: vueAppConfig.isActiveSearchByPromoCode,
				isGuestsAgesRequired: vueAppConfig.isGuestsAgesRequired,
				adultAge:-1,
				formErrors: {},
				popUpWindowClosedInside: false,
				datePicker:{
					cacheTime: vueAppConfig.datePickerCalendarCacheTime, //milliseconds
					cache:{dd:{}, pdp:{}},
					loading: {},
				},
				fePreBookingData:{
					apmsData:{title:'',description:'',available_pms:[]},
				},
			};
		},
		watch:{
			'inData.client': {
				deep: true,
				handler:function (newVal,oldVal) {
					if(this.inData.client.booking_for_someone_else){ return; }

					let all_keys = Object.keys(this.inData.guests);
					if(!all_keys.length){return;}

					let key = all_keys[0];//get the first key
					let item = {first_name:newVal.first_name||'', last_name:newVal.last_name||''};
					if(this.isGuestsAgesRequired){
						item.age = this.adultAge;//adult age
					}

					this.$set(this.inData.guests[key], 0, item);
				},
			},
			'inData.client.booking_for_someone_else': function(newVal){
				let indx = Object.keys(this.inData.guests)[0];
				let guest = this.inData.guests[indx][0];
				let item = null;
				if(newVal){
					if(guest.first_name==this.inData.client.first_name && guest.last_name==this.inData.client.last_name){
						item = {first_name:'', last_name:''};
					}
				}
				else{
					if(guest.first_name=='' && guest.last_name==''){
						item = {first_name:this.inData.client.first_name, last_name:this.inData.client.last_name};
					}
				}

				if(item){
					if(this.isGuestsAgesRequired) item.age = this.adultAge;//adult age
					this.$set(this.inData.guests[indx], 0, item);
				}
			},
		},
		computed:{
			cp_lngLocale(){
				return this.$i18n.locale;
			},
			cp_searchFormClasses(){
				let tmp = [];
				tmp.push(this.isActiveRoomsGuestsControl?'sfc-rg-on':'sfc-rg-off');
				tmp.push(this.isActiveSearchByPromoCode?'sfc-pc-on':'sfc-pc-off');
				return tmp.join(' ');
			},
			cp_NumNights(){
				return this.inData.nights ? this.inData.nights : 0;
			},
			//selectedRooms
			cp_selectedRRA(){
				let data = [];
				for (const i in this.inData.selectedRooms.byRoomRateAcm){
					data.push(this.inData.selectedRooms.byRoomRateAcm[i])
				}
				for (const i in this.inData.selectedRooms.byRoomRate){
					for(const j in this.inData.selectedRooms.byRoomRate[i]){
						data.push(this.inData.selectedRooms.byRoomRate[i][j]);
					}
				}
				return data;
			},
			cp_RoomsQty(){
				let roomsQtys = {};
				for(const item of this.cp_selectedRRA){
					let room_id = parseInt(item.room_id);
					if(!(room_id in roomsQtys)) roomsQtys[room_id] = 0;
					roomsQtys[room_id] += item.selected_qty;
				}
				return roomsQtys;
			},
			cp_NumRooms(){
				return Object.values(this.cp_RoomsQty).reduce((prev, curr)=>{return prev + curr}, 0);
			},
			cp_Guests(){
				let result = {adults:0, children:0}
				for(const item of this.cp_selectedRRA){
					result.adults += item.numAdults*item.selected_qty;
					result.children += item.numChildren*item.selected_qty;
				}
				return result;
			},
			cp_selectedRRATotalAmount(){
				let sum = 0;
				for(const item of this.cp_selectedRRA){
					if(!item.acm_items) continue;
					//sum += item.selected_qty * item.acm_items.reduce((acc, v)=>{return acc + v.price}, 0);
					sum += item.selected_qty * item.price;
				}
				return sum;
			},
			cp_selectedRRATotalAmountFormatted(){
				return formatAmount(this.cp_selectedRRATotalAmount, this.currency, this.precision, true, this.$i18n.locale);
			},

			//selectedRoomItems
			cp_selectedRoomItemsTotalAmount(){
				let sum = 0;
				for(const i in this.inData.selectedRoomItems){
					sum += this.inData.selectedRoomItems[i].price;
					if(this.inData.selectedRoomItems[i].es_ss_ids){
						for(const es_id in this.inData.selectedRoomItems[i].es_ss_ids){
							let extra = this.inData.selectedRoomItems[i].es_ss_ids[es_id];
							sum += extra.price*extra.qty;
						}
					}
				}
				return sum;
			},
			cp_selectedRoomItemsTotalAmountFormatted(){
				return formatAmount(this.cp_selectedRoomItemsTotalAmount, this.currency, this.precision, true, this.$i18n.locale);
			},
			cp_hasFormErrors(){
				return Object.keys(this.formErrors).length>0;
			},
			cp_qitModalDialogFormErrors(){
				if(this.cp_hasFormErrors){
					return this.formErrors.main ? Object.values(this.formErrors.main).join(' ') : this.$t('errors.pleaseFixErrors');
				}
				return '';
			},
			dpDisabledDates(){
				const res = [];
				for(const ymd in this.datePicker.cache.dd){
					res.push(...this.datePicker.cache.dd[ymd].data);
				}
				return res;
			},
			dpPeriodDates(){
				const res = [];
				for(const ymd_ccc in this.datePicker.cache.pdp){
					if(ymd_ccc.slice(-3)===this.currency){
						res.push(...this.datePicker.cache.pdp[ymd_ccc].data);
					}
				}
				return res;
			},
		},
		methods:{
			isUndefined(v){
				return typeof(v)==='undefined';
			},
			isNotObject(v){
				return typeof(v)==='undefined' || !v || Array.isArray(v);
			},
			onSubmitSearchForm(ev){
				let isSubmitActive = true;
				if(!this.$refs.qDatepickerRange.validate()){
					isSubmitActive = false;
				}
				if(this.isActiveRoomsGuestsControl && !this.$refs.qSearchRoomsGuests.validate()) {
					isSubmitActive = false;
				}
				if(!isSubmitActive){
					ev.preventDefault();
					return false;
				}
			},
			getSelectedRoomQty(room_id){
				const qty = this.cp_RoomsQty[parseInt(room_id)];
				return qty ? qty : 0;
			},
			async getPriceForGuests(room_id, rate_id, numAdults, childrenByAgesOnBed, childrenByAgesNoBed){
				return await doFetch(vueAppConfig.currentPageUrl, {action:'getPriceForGuests'}, {
					room_id: room_id,
					rate_id: rate_id,
					fromDate: this.inData.start,
					numNights: this.inData.nights,
					numAdults: numAdults,
					childrenByAgesOnBed: childrenByAgesOnBed,
					childrenByAgesNoBed: childrenByAgesNoBed
				});
			},
			onChangeAllInOnePayment(){
				this.$nextTick(() => { this.reloadBookingPayment(); });
			},
			onChangePaymentMethod(){
				this.$nextTick(() => { this.reloadBookingPayment(); });
			},
			async reloadBookingPayment(){
				this.$refs.qConfirmForm.classList.add('submitting');

				const res = await doFetch(vueAppConfig.currentPageUrl, {action:'reloadBookingPayment'}, this.inData);

				this.$refs.qConfirmForm.classList.remove('submitting');

				if(res && res.success){
					this.$refs.bookingPaymentAmounts.innerHTML = res.html ? res.html : 'Error !!!';
					this.setFePreBooking_apmsData(res.apmsData ? res.apmsData : {title:'', description:'Unknown error!', available_pms:[]});
				}
				else {
					this.formErrors = res && res.errors ? res.errors : {main:['Unknown error!!!']};
					this.$refs.qitModalDialogFormErrors.show(10000);
					this.$nextTick(()=>{
						const elErrorMsg = this.$refs.qConfirmForm.querySelector('.error-msg');
						if(elErrorMsg){
							elErrorMsg.scrollIntoView({behavior:"auto",block:"center",inline:"start"});
						}
					});
				}
			},
			//social login
			onGoogleSignIn(clientData){
				let client = {}
				client['first_name'] = clientData.first_name ? clientData.first_name : '';
				client['last_name'] = clientData.last_name ? clientData.last_name : '';
				client['email'] = clientData.email ? clientData.email : '';
				client['phone'] = clientData.phone ? clientData.phone : '';
				Vue.set(this.inData, 'client', client);
			},
			onFacebookSignIn(clientData){
				let client = {}
				client['first_name'] = clientData.first_name ? clientData.first_name : '';
				client['last_name'] = clientData.last_name ? clientData.last_name : '';
				client['email'] = clientData.email ? clientData.email : '';
				client['phone'] = clientData.phone ? clientData.phone : '';
				Vue.set(this.inData, 'client', client);
			},
			onClickLangMenu(ev){
				if(this.$refs.langMenu){
					this.$refs.langMenu.classList.toggle('show');
				}
			},
			getFormFieldError(name, defValue=null){
				return getObjectPathValue(this.formErrors, name.split('.'), defValue);
			},
			async onConfirmFormSubmit(event){
				this.$refs.qConfirmForm.classList.add('submitting');

				const res = await doFetch(vueAppConfig.currentPageUrl, {action:'btnSubmit'}, new FormData(this.$refs.qConfirmForm));

				if(!res || !res.success){
					this.formErrors = res && res.errors ? res.errors : {main:['Unknown error!!!']};
					this.$refs.qConfirmForm.classList.remove('submitting');
					this.$refs.qitModalDialogFormErrors.show(10000);
					this.$nextTick(()=>{
						const elErrorMsg = this.$refs.qConfirmForm.querySelector('.error-msg');
						if(elErrorMsg){
							elErrorMsg.scrollIntoView({behavior:"auto",block:"center",inline:"start"});
						}
					});
					return;
				}

				if(vueAppConfig.isIframeRender && res.pay_url){
					const popUpWindow = window.open(res.pay_url, '_blank', 'popup,width=700,height=800');
					const intervalId = window.setInterval(()=>{
						if (popUpWindow.closed) {
							window.clearInterval(intervalId);

							if(this.popUpWindowClosedInside) return;

							if(window.location.href.indexOf('/success/')===-1){
								window.location.href = res.success_url;
							}
						}
					}, 100);
					return;
				}

				window.location.href = res.pay_url ? res.pay_url : res.success_url;
			},
			onLoadSuccessPageFromPopUpWindow(popUpWindow){
				if(vueAppConfig.isIframeRender){
					if(window.location.origin!==popUpWindow.location.origin){
						return; //console.log('Diff window.location.origin');
					}
					let newPageUrl = popUpWindow.location.href;
					if(newPageUrl.indexOf('/success/')===-1){
						return; //console.log('newPageUrl => Not success page');
					}
					if(newPageUrl.indexOf('iframe=1')===-1){
						newPageUrl += '&iframe=1';
					}
					if(window.location.href===newPageUrl){
						return; //prevent eventually redirection loop
					}
					window.location.href = newPageUrl;

					this.popUpWindowClosedInside = true;
					this.$nextTick(() => {
						popUpWindow.close();
					});
				}
			},
			onLoadBookingCalendarDatePickerDates(dpItems){
				let cmsTime = Date.now();
				const items = {};
				const loadingItemsKeys = [];
				for(const fld in dpItems){
					for(const ymd of dpItems[fld]) {
						const cacheKey = ymd + (fld==='dd'?'':this.currency);

						if(this.datePicker.cache[fld][cacheKey] && (cmsTime - this.datePicker.cache[fld][cacheKey].cms)<this.datePicker.cacheTime){
							continue; //cache time not elapsed
						}
						if(this.datePicker.loading[fld+cacheKey]){
							continue; //in loading process
						}
						this.$set(this.datePicker.loading, fld+cacheKey, true);
						loadingItemsKeys.push(fld+cacheKey);

						if(!items[fld]){ items[fld] = []; }

						items[fld].push(ymd);
					}
				}

				if(!Object.keys(items).length){ return; }

				doFetch(vueAppConfig.homePageUrl, {action:'getBCDPDates'}, {items:items})
					.then((res) => {
						if (!res || !res.success || !res.items){
							const msg = JSON.stringify({msg:"Fetch error for DatePicker!", url:vueAppConfig.homePageUrl, post:{items:items}, response:res});
							throw new Error(msg);
						}

						const cmsTime = Date.now();

						for(const fld in res.items){
							if(fld!=='dd' && fld!=='pdp') continue;

							for(const ymd in res.items[fld]){
								const cacheKey = ymd + (fld==='dd'?'':this.currency);
								this.$set(this.datePicker.cache[fld], cacheKey, {
									cms : cmsTime,
									data: res.items[fld][ymd],
								});
							}
						}

						if(this.datePicker.cacheTime>0){
							setSessionStorageItem('datePicker.cache', this.datePicker.cache);
						}
					})
					.catch((error)=>{
						//error
					})
					.finally(()=>{
						for(const key of loadingItemsKeys){
							this.$delete(this.datePicker.loading, key);
						}
					});
			},
			changeDatepickerViewedMonths(isoMonthsDates){
				const dpItems = {};
				if(vueAppConfig.isActiveShowDisabledDatesOnCalendar){
					dpItems.dd = [];
				}
				if(vueAppConfig.isActiveShowPricesOnCalendar){
					dpItems.pdp = [];
				}

				for (const i in isoMonthsDates){
					for(const fld in dpItems){
						dpItems[fld].push(isoMonthsDates[i]);
					}
				}

				if(Object.keys(dpItems).length){
					this.onLoadBookingCalendarDatePickerDates(dpItems);
				}
			},
			setFePreBooking_apmsData(apmsData){
				if(!apmsData){
					alert('Unknown error!');
					return;
				}
				this.$set(this.fePreBookingData, 'apmsData', apmsData);

				if(this.inData.payment_method){
					let is_exists = false;
					if(apmsData.available_pms){
						for(const i in apmsData.available_pms){
							if(this.inData.payment_method==apmsData.available_pms[i].id){
								is_exists = true;
								break;
							}
						}
					}
					if(!is_exists){
						this.$set(this.inData, 'payment_method', null);
					}
				}
			},
			initDatePickerCache(){
				const cache = {dd:{}, pdp:{}};
				const ssItem = getSessionStorageItem('datePicker.cache');
				if(vueAppConfig.isActiveShowDisabledDatesOnCalendar && ssItem && ssItem.dd) {
					cache.dd=ssItem.dd;
				}
				if(vueAppConfig.isActiveShowPricesOnCalendar && ssItem && ssItem.pdp) {
					cache.pdp=ssItem.pdp;
				}
				this.$set(this.datePicker, 'cache', cache);
			},
		},
		created(){
			this.initDatePickerCache();
		},
		mounted(){
			for(let i=1;i<=2;i++){
				if(this.$refs[`scrollPageToMe${i}`]){
					this.$refs[`scrollPageToMe${i}`].scrollIntoView({behavior:"auto", block:"start", inline:"start"});
					break;
				}
			}
			window.addEventListener('click', (ev)=>{
				if(this.$refs.langMenu && this.$refs.langMenu.classList.contains('show') && !this.$refs.langMenu.contains(ev.target)){
					this.$refs.langMenu.classList.remove('show');
				}
			});

			document.body.classList.add('on-page-loaded');

			window.addEventListener("beforeunload", function (e) {
				document.body.classList.remove('on-page-loaded');
				document.body.classList.add('on-page-unloaded');
			});
		}
	});
}

//window.createVueApp = createVueApp;
export {createVueApp as default, Vue};